export default "__VITE_ASSET__hFtnOMx1__"